export default {
  loginRequest: {
    email: '',
    password: '',
    remember: false
  },
  resetPasswordRequest: {
    token: '',
    id: '',
    password: '',
    confirmPassword: ''
  },
  status: {},
  twoFactorAuthRequired: false,
  isTwoFactorAuthEmailOrSMS: false
};